export * from './deactivated_icon';
